import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { useTranslation } from "common/locales";
import useConfirmation from "common/utils/useConfirmation";
import { AnimalGroup, useDeleteAnimalGroup } from "model";
import { MouseEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppStore } from "stores";
import { mixpanel } from "../../common/analytics";

export default function AnimalGroupMenu({ guid, name }: AnimalGroup) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { t } = useTranslation();
  const confirmDeleteGroup = useConfirmation({
    title: t("confirmationdeletedialog.animalGroup.title"),
    description: t("confirmationdeletedialog.animalGroup.description", {
      name,
    }),
  });
  const navigate = useNavigate();
  const currentFarmId = useAppStore((state) => state.currentFarmId);

  // Use React Query mutation
  const deleteAnimalGroupMutation = useDeleteAnimalGroup();

  return (
    <div>
      <IconButton
        edge="end"
        aria-haspopup="true"
        onClick={open}
        size="small"
        sx={{
          backgroundColor: "#F1EFF7",
          color: "#7D5DA3",
          "&:hover": { backgroundColor: "#E5E1F0" },
        }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={close}
      >
        <MenuItem
          to={`/edit-animal-group/${guid}`}
          component={Link}
          onClick={close}
        >
          {t("animalGroup.menu.edit")}
        </MenuItem>
        <MenuItem onClick={deleteGroup}>
          {t("animalGroup.menu.delete")}
        </MenuItem>
      </Menu>
    </div>
  );

  async function deleteGroup() {
    close();
    const confirmed = await confirmDeleteGroup();
    if (confirmed) {
      await deleteAnimalGroupMutation.mutateAsync(guid);
      mixpanel.track("AnimalGroup deleted");
      navigate(`/farm/${currentFarmId || ""}`);
    }
  }

  function open(event: MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
  }

  function close() {
    setAnchorEl(null);
  }
}
